<template>
  <div class="p-fluid">
    <div class="p-col-12 info_product_serial" >
      <div class="p-field">
        <div class="p-field">
          <label class="title_group_lookup">THÔNG TIN KHÁCH HÀNG</label>
        </div>
      </div>
      <div class="p-field box_group_item">
        <div class="form-info">
          <div class="p-field">
            <label>Tên khách hàng</label>
            <div class="box-value" >
              <span>{{ (objectPopup.object_info_product) ? objectPopup.object_info_product.full_name:'' }}</span>
            </div>
          </div>
          <div class="p-field">
            <label>Số điện thoại</label>
            <div class="box-value" >
              <span>{{ (objectPopup.object_info_product) ? objectPopup.object_info_product.phone_number:'' }}</span>
            </div>
          </div>
          <div class="p-field">
            <label>Nhóm khách hàng</label>
            <div class="box-value" >
              <span>{{ (objectPopup.object_info_product) ? objectPopup.object_info_product.group_customer:'' }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="p-field">
        <div class="p-field">
          <label class="title_group_lookup">THÔNG TIN SẢN PHẨM</label>
        </div>
      </div>
      <div class="p-field box_group_item">
        <div class="form-info">
          <div class="p-field">
            <label>Trạng thái bảo hành</label>
            <div class="box-value" >
              <span v-html="(objectPopup.object_info_product) ? objectPopup.object_info_product.warranty_status_html:''"></span>
            </div>
          </div>
          <div class="p-field">
            <label>Model sản phẩm</label>
            <div class="box-value" >
              <span>{{ (objectPopup.object_info_product) ? objectPopup.object_info_product.model_code:'' }}</span>
            </div>
          </div>
          <div class="p-field">
            <label>Tên sản phẩm</label>
            <div class="box-value" >
              <span>{{ (objectPopup.object_info_product) ? objectPopup.object_info_product.product_name:'' }}</span>
            </div>
          </div>
          <div class="p-field">
            <label>Serial number</label>
            <div class="box-value" >
              <span>{{ (objectPopup.object_info_product) ? objectPopup.object_info_product.serial_number:'' }}</span>
            </div>
          </div>
          <div class="p-field">
            <label>Nhóm sản phẩm</label>
            <div class="box-value" >
              <span>{{ (objectPopup.object_info_product) ? objectPopup.object_info_product.categories_name:'' }}</span>
            </div>
          </div>
          <div class="p-field">
            <label>Thời hạn bảo hành</label>
            <div class="box-value" >
              <span v-html="(objectPopup.object_info_product) ? objectPopup.object_info_product.warranty_time:''"></span>
            </div>
          </div>
          <div class="p-field">
            <label>Thời hạn đổi</label>
            <div class="box-value" >
              <span v-html="(objectPopup.object_info_product) ? objectPopup.object_info_product.change_time:''"></span>
            </div>
          </div>
          <div class="p-field">
            <label>Thời hạn trả</label>
            <div class="box-value" >
              <span v-html="(objectPopup.object_info_product) ? objectPopup.object_info_product.returnable_time:''"></span>
            </div>
          </div>
          <div class="p-field">
            <label>Ngày sản xuất</label>
            <div class="box-value" >
              <span >{{ (objectPopup.object_info_product) ? objectPopup.object_info_product.created_date:'' }}</span>
            </div>
          </div>
          <div class="p-field">
            <label>Ngày kích hoạt bảo hành</label>
            <div class="box-value" >
              <span>{{ (objectPopup.object_info_product) ? objectPopup.object_info_product.activation_date:'' }}</span>
            </div>
          </div>
          <div class="p-field">
            <label>Ngày hết hạn bảo hành</label>
            <div class="box-value" >
              <span>{{ (objectPopup.object_info_product) ? objectPopup.object_info_product.expired_activation_date:'' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        props: {
          objectPopup: Object,
        },
        data() {
            return {
            }
        },
        mounted () {
        },
        methods: {
        },
    }
</script>

<style lang="scss">
.title_group_lookup{
  font-weight: 700; font-style: normal; font-size: 16px;
}

.form-info{
  .message_err{
    text-align: right!important;font-weight: 400; font-style: italic; color: #FF0000; font-size: 14px;margin-bottom: 0px
  }
  .p-field{ padding: 10px;
    &:nth-child(n) {background: #E4E4E4;}
    &:nth-child(2n) {background: #fff;}
    label{ width: 200px; margin: 0;}
    .box-status{
      position: relative;
      background-color: rgba(153, 0, 204, 1);
      border-radius: 5px;
      text-align: center;
      //midle vertical
      display: inline-block;
      vertical-align: middle;
      padding-left: 9px;
      padding-right: 10px;
      padding-top: 2px;
      padding-bottom: 2px;
      .style-text-status{
        font-family: 'Arial Bold', 'Arial';
        font-weight: 700;
        font-style: normal;
        font-size: 14px;
        color: #FFFFFF;
      }
    }
    .box-value{
      width: calc(100% - 220px);//căn chỉnh để xuống thẳng hàng
      display: inline-block;
    }
  }
  .box-button{
    margin-top: 10px;
    .btn-done{
      width: 120px;
      float: left;
      margin-right: 32px;
      background: linear-gradient(180deg, rgba(66, 139, 202, 1) 0%, rgba(66, 139, 202, 1) 0%, rgba(45, 108, 162, 1) 100%, rgba(45, 108, 162, 1) 100%) !important;
      border: 1px solid #428bca;
      font-family: 'Arial Bold', 'Arial';
      font-weight: 700;
      font-style: normal;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 24px;
    }
    .btn-false-report{
      width: 120px;
      background: linear-gradient(180deg, rgb(240, 173, 78) 0%, rgba(240, 173, 78, 1) 0%, rgba(235, 147, 22, 1) 100%, rgba(235, 147, 22, 1) 100%);
      border: 1px solid #F0AD4E;
      font-family: 'Arial Bold', 'Arial';
      font-weight: 700;
      font-style: normal;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 24px;
    }
  }
}
</style>